import * as types from "./types.js"
import * as api from "./api.js"


function getContactsRequest() {
    return {
        type: types.GET_CONTACTS_REQUEST
    }
}

function getContactsReceived(contacts) {
    return {
        type: types.GET_CONTACTS_RECEIVED,
        payload: contacts
    }
}

function getContactsError(e) {
    return {
        type: types.GET_CONTACTS_ERROR,
        payload: e,
        error: true
    }
}

export function getContacts(personid) {
    return dispatch => {
        dispatch(getContactsRequest())
        return api.getContacts(personid)
        .then(res => {
            if (res.status !== 200) {
                dispatch(getContactsError(res.statusText))
            } else {
                return res.json()
                .then(contacts => {
                    dispatch(getContactsReceived(contacts))
                })
            }
        })
    }
}


function postContactRequest() {
    return {
        type: types.POST_CONTACT_REQUEST
    }
}

function postContactReceived(contact) {
    return {
        type: types.POST_CONTACT_RECEIVED,
        payload: contact
    }
}

function postContactError(e) {
    return {
        type: types.POST_CONTACT_ERROR,
        payload: e,
        error: true
    }
}

export function postContact(contact) {
    return dispatch => {
        dispatch(postContactRequest())
        return api.postContact(contact)
        .then(res => {
            if (res.status !== 200) {
                dispatch(postContactError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(postContactReceived({
                        id: stats.id,
                        contact: contact.contact,
                        value: contact.value
                    }))
                })
            }
        })
    }
}

function deleteContactRequest() {
    return {
        type: types.DELETE_CONTACT_REQUEST
    }
}

function deleteContactReceived(contact) {
    return {
        type: types.DELETE_CONTACT_RECEIVED,
        payload: contact
    }
}

function deleteContactError(e) {
    return {
        type: types.DELETE_CONTACT_ERROR,
        payload: e,
        error: true
    }
}

export function deleteContact(id) {
    return dispatch => {
        dispatch(deleteContactRequest())
        return api.deleteContact(id)
        .then(res => {
            if (res.status !== 200) {
                dispatch(deleteContactError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(deleteContactReceived({ id }))
                })
            }
        })
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/profile/contacts/actions.js
 **/